import { useEmbeds } from "./use-embeds";
import { mapValues, keyBy } from 'lodash';
import { useMemo } from "react";
export var useEmbedsBySlug = function () {
  var embeds = useEmbeds();
  return useMemo(function () {
    return mapValues(embeds, function (entityEmbeds) {
      return keyBy(entityEmbeds, 'slug');
    });
  }, [embeds]);
};